import CONSTANTS from "@/common/constants";

const loginRoutes = [
  {
    path: "/login",
    name: CONSTANTS.ROUTE.NAME.LOGIN,
    component: () => import("@/views/Login/Login.vue"),
    meta: {
      layout: "NO_HEADER",
    },
  },
  {
    path: "/register",
    name: CONSTANTS.ROUTE.NAME.REGISTER,
    component: () => import("@/views/Login/Register.vue"),
    meta: {
      layout: "NO_HEADER",
    },
  },
  {
    path: "/invite",
    name: CONSTANTS.ROUTE.NAME.INVITE,
    component: () => import("@/views/Login/Invite.vue"),
    meta: {
      layout: "NO_HEADER",
    },
  },
  {
    path: "/password",
    name: CONSTANTS.ROUTE.NAME.PASSWORD,
    component: () => import("@/views/Login/Password.vue"),
    meta: {
      layout: "NO_HEADER",
    },
  },
  {
    path: "/finduser",
    name: CONSTANTS.ROUTE.NAME.FINDUSER,
    component: () => import("@/views/Login/FindUser.vue"),
    meta: {
      layout: "NO_HEADER",
    },
  },
];

export default loginRoutes;
